import React from "react"
import { ResponsiveImageElement } from "./styled"

type ResponsiveImageProps = {
  src: string
  maxWidth?: number
}

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  src,
  maxWidth,
}) => {
  return <ResponsiveImageElement src={src} maxWidth={maxWidth} />
}
